import exception from './exception'
import VueRouter from 'vue-router'
import console from './console'
import user from './user'


export default new VueRouter({ mode: 'history', routes: [console, user, exception] })